var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.token)?_c('navbar'):_vm._e(),_c('v-main',{staticStyle:{"background":"#fafafa"},attrs:{"light":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }